import React from 'react';

let AbsoluteFormWrapper = (props) => {
  let { children } = props;
  return <div className="absolute top-0 right-0 bottom-0 left-0 bg-zinc-100 z-10 flex flex-col pb-4">{children}</div>;
};
export default AbsoluteFormWrapper;
